import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} offers
 * @returns {Workbook}
 */
export const exportExcel = async (offers) => {
  offers.forEach((offer, index) => {
    offer.order = index + 1;

    offer.expirationDateFormat = formatHelper.toDateDDMMYYY(
      offer.expirationDate
    );
  });

  const json = excelHelper.jsonToJson(
    [offers],
    [
      {
        name: "OFERTAS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
          {
            inValue: "expirationDateFormat",
            outValue: "FECHA DE EXPIRACION",
          },
          {
            inValue: "total_price",
            outValue: "PRECIO TOTAL",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName();
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = () => {
  return (
    formatHelper.toDateYYMMDD(new Date().toUTCString()) +
    "_reporte-general-ofertas.xlsx"
  );
};



// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferList/excel.js